<template>
  <div id="topbar">{{ appName }}</div>
  <Toast/>
  <HelloWorld/>

</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Toast from 'primevue/toast';
import 'primeicons/primeicons.css'

export default {
  name: 'App',
  components: {
    HelloWorld, Toast
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      appColor: process.env.VUE_APP_COLOR,
    }
  },
  mounted() {
    document.title = this.appName
  }
}


</script>

<style>

:root {
  --body-background-color: #efefef;
}

html,body{
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;
  background-color: var(--body-background-color);
  padding: 10px 0 0 0 ;
}
#topbar{
  background: v-bind(appColor);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  color: #fff;
  text-align: center;
  padding: 5px;
  z-index: 9999;

}
#app {

  min-height: 100vh;
}

.panels{
  min-height: 100vh;
}

.p-overlay-mask{
  background: rgba(255,255,255,0.7) !important;
}

</style>